export default __webpack_public_path__ + "2f96499bd1ead36243a2d0be94bdd587.png";